
  class DrawerElement extends HTMLElement {

    static GLOBAL_STYLE = `
      .drw-backdrop {
        display: block !important;
        position: fixed; inset: 0;
        z-index: 10000;
        background: rgba(0,0,0,0);
        pointer-events: none;
        transition: background var(--duration-long) cubic-bezier(0.32, 0.72, 0, 1);
      }
      .drw-backdrop.is-open {
        background: rgba(0,0,0,.38);
        pointer-events: auto;
      }

      .drw-blur {
        display: block !important;
        position: fixed; inset: 0;
        z-index: 10000;
        pointer-events: none;
        backdrop-filter: blur(0px);
        -webkit-backdrop-filter: blur(0px);
        transition: backdrop-filter var(--duration-long) cubic-bezier(0.32, 0.72, 0, 1);
      }
      .drw-blur.is-open {
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
      }

      .drw-panel {
        display: flex !important;
        flex-direction: column;
        position: fixed;
        z-index: 10001;
        overflow: hidden;
        transition: transform var(--duration-long) cubic-bezier(.32,.72,0,1);

        --drw-bg:          #181818;
        --drw-color:       #eee;
        --drw-border:      #e2e0da;
        --drw-radius:      4px;
        --drw-header-bg:   #c8a84b08;
        --drw-header-fg:   #f0ede6;
        --drw-accent:      #c8b560;
        --drw-close-hover: #c84040;
        --drw-font:        Georgia, 'Times New Roman', serif;
        --drw-font-ui:     system-ui, sans-serif;
        --drw-shadow-b:    0 -4px 40px rgba(0,0,0,.14), 0 -1px 8px rgba(0,0,0,.06);
        --drw-shadow-r:    -4px 0 40px rgba(0,0,0,.14), -1px 0 8px rgba(0,0,0,.06);

        background: var(--drw-bg);
      }
      .drw-panel[data-dir="bottom"] {
        bottom: 0; left: 0; right: 0;
        height: var(--drw-size, 50vh); max-height: 92vh;
        border-radius: var(--drw-radius) var(--drw-radius) 0 0;
        box-shadow: var(--drw-shadow-b);
        transform: translateY(105%);
      }
      .drw-panel[data-dir="bottom"].is-open { transform: translateY(0); }

      .drw-panel[data-dir="right"] {
        top: 0; right: 0; bottom: 0;
        width: 100%;
        border-radius: var(--drw-radius) 0 0 var(--drw-radius);
        box-shadow: var(--drw-shadow-r);
        transform: translateX(105%);
      }
      .drw-panel[data-dir="right"].is-open { transform: translateX(0); }

      @media screen and (min-width: 768px) {
        .drw-panel[data-dir="right"] {
          width: 40vw !important;
          max-width: 96vw;
        }
      }

      .drw-panel[data-dir="right"] {
        width: 90%;
      }

      @media screen and (min-width: 480px) {
        .drw-panel[data-dir="right"] {
          width: 100%;
          max-width: 400px;
        }
      }

      .drw-handle {
        display: none;
        justify-content: center; align-items: center;
        padding: 12px 0 6px;
        cursor: grab; flex-shrink: 0;
        user-select: none; -webkit-user-select: none; touch-action: none;
      }
      .drw-panel[data-dir="bottom"] .drw-handle { display: flex; }
      .drw-handle::after {
        content: '';
        width: 40px; height: 4px; border-radius: 2px;
        background: var(--drw-border);
        transition: width .18s ease, background .18s ease;
      }
      .drw-handle.is-dragging::after { width: 56px; background: #aaa; }
      .drw-handle:active { cursor: grabbing; }

      .drw-header {
        display: flex; align-items: center; gap: 12px;
        padding: 14px 20px 14px 24px;
        background: var(--drw-header-bg); color: var(--drw-header-fg);
        font-family: var(--drw-font); font-size: 1.05rem; letter-spacing: .03em;
        flex-shrink: 0; border-bottom: 1px solid rgba(255,255,255,.07);
        user-select: none; -webkit-user-select: none; touch-action: none;
      }
      .drw-accent {
        width: 6px; height: 6px; border-radius: 50%;
        background: var(--drw-accent); flex-shrink: 0;
        display: none;
      }
      .drw-title {
        flex: 1; font-weight: normal; margin: 0; font-size: inherit;
        color: var(--drw-header-fg); font-family: var(--drw-font);
      }
      .drw-close {
        width: 32px; height: 32px; border-radius: 8px;
        border: 1px solid rgba(255,255,255,.12); background: rgba(255,255,255,.06);
        color: var(--drw-header-fg); cursor: pointer;
        display: flex; align-items: center; justify-content: center;
        flex-shrink: 0; padding: 0; line-height: 1;
        transition: background .18s, border-color .18s, color .18s;
      }
      .drw-close:hover {
        background: var(--drw-close-hover);
        border-color: var(--drw-close-hover); color: #fff;
      }
      .drw-close svg {
        width: 14px; height: 14px;
        stroke: currentColor; fill: none; stroke-width: 2; stroke-linecap: round;
        pointer-events: none;
      }

      .drw-body {
        flex: 1; overflow-y: auto; padding: 24px;
        font-family: var(--drw-font-ui); color: var(--drw-color);
        scrollbar-width: thin; scrollbar-color: var(--drw-border) transparent;
      }
      .drw-body::-webkit-scrollbar { width: 5px; }
      .drw-body::-webkit-scrollbar-thumb { background: var(--drw-border); border-radius: 3px; }

      body.drawer-open {
        overflow: hidden;
        padding-right: var(--drawer-scrollbar-width, 0px);
      }

      .drw-body h2 {
        font-weight: 700;
        color: rgb(var(--color-base-accent));
        margin: 0;
      }
      .drw-body h3, .drw-body h4 {
        font-weight: bold;
        margin-bottom: 1rem;
      }
      .drw-body h4 { margin-bottom: 0; }
      .drw-body p, .drw-body ul {
        font-size: 13px;
        line-height: 1.7;
      }
      .drw-body p:first-child {
        padding-top: 0;
        margin-top: 0;
      }
      .drw-body ul { padding-left: 2rem; }
      .drw-body figure {
        margin: 0 0 1rem;
        border-radius: 6px;
        overflow: hidden;
        background: #f5f5f5;
      }
      .drw-body figure img {
        width: 100%;
        display: block;
      }
      .drw-body mark {
        font-size: 0.6875rem;
        background: #e8f0fb;
        color: #1a56a0;
        border-radius: 4px;
        padding: 2px 6px;
        display: inline-block;
        margin-bottom: 0.5rem;
      }
      .drw-body blockquote {
        background: #f5f5f5;
        border-left: none;
        border-radius: 6px;
        padding: 0.75rem;
        margin: 0;
        font-size: 0.875rem;
        color: #555;
      }
      .drw-compare {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        margin-bottom: 1rem;
      }
      .drw-compare-container {
        position: relative; 
        text-align: start;
      }
      .drw-compare .drw-compare-badge{
        position:absolute;
        top:-5px;
        right:-5px;
        width:30px;
        height:30px;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        z-index:2;
        box-shadow:0 2px 6px rgba(0,0,0,.45);
      }

      /* Falsch → rotes X */
      .drw-compare-badge--wrong{ background:#d23b30; }
      .drw-compare-badge--wrong::before,
      .drw-compare-badge--wrong::after{
        content:"";
        position:absolute;
        width:14px;
        height:2.5px;
        border-radius:2px;
        background:#fff;
      }
      .drw-compare-badge--wrong::before{ transform:rotate(45deg); }
      .drw-compare-badge--wrong::after { transform:rotate(-45deg); }

      /* Richtig → grüner Haken */
      .drw-compare-badge--right{ background: var(--color-success);}
      .drw-compare-badge--right::after{
        content:"";
        width:7px;
        height:12px;
        margin-top:-2px;
        border:solid #fff;
        border-width:0 2.6px 2.6px 0;
        transform:rotate(45deg);
      }
      .drw-compare > div {
        border: 1px solid rgb(60 60 60);
        border-radius: 6px;
        padding: 1rem;
      }
      .drw-compare > div.highlight { border-color: rgb(var(--color-base-accent)); }
      .drw-compare > div figure { aspect-ratio: 3 / 4; }
      .drw-compare > div:has(mark) {
        border-color: #1a56a0;
        border-width: 2px;
      }
      .drw-compare p:last-child { margin-bottom: 0; }
      .drw-body img { width: 100%; }
    `;

    static SHADOW_STYLE = `
      :host { display: contents; }
      ::slotted(*) { display: none !important; }
    `;

    static VELOCITY_THRESHOLD = 0.4;
    static DISTANCE_RATIO     = 0.40;
    static RESISTANCE         = 0.30;
    static SPRING_DUR         = '420ms';
    static SPRING_EASE        = 'cubic-bezier(.34,1.56,.64,1)';
    static DISMISS_DUR        = '260ms';
    static DISMISS_EASE       = 'cubic-bezier(.4,0,1,1)';

    // ─── Statische Hilfsmethode ──────────────────────────────────────────────────

    static ensureGlobalStyles() {
      if (document.getElementById('drw-global-styles')) return;
      const el = document.createElement('style');
      el.id          = 'drw-global-styles';
      el.textContent = DrawerElement.GLOBAL_STYLE;
      document.head.appendChild(el);
    }

    // ─── observedAttributes ──────────────────────────────────────────────────────

    static get observedAttributes() {
      return ['open', 'direction', 'close-on-outside', 'require-button',
              'no-drag', 'trigger', 'size', 'label', 'mobile-only', 'touch-only',
              'mobile-breakpoint', 'mode'];
    }

    // ─── constructor ─────────────────────────────────────────────────────────────

    constructor() {
      super();

      const shadow = this.attachShadow({ mode: 'open' });
      const style  = document.createElement('style');
      style.textContent = DrawerElement.SHADOW_STYLE;

      this._slotHeader  = document.createElement('slot');
      this._slotHeader.name = 'header';
      this._slotDefault = document.createElement('slot');

      shadow.appendChild(style);
      shadow.appendChild(this._slotHeader);
      shadow.appendChild(this._slotDefault);

      this._backdrop = null;
      this._blurEl   = null;
      this._panel    = null;
      this._handle   = null;
      this._header   = null;
      this._title    = null;
      this._body     = null;

      this._triggerEl      = null;
      this._triggerHandler = null;
      this._ds             = null;
      this._movedNodes     = [];

      this._onCloseClick    = () => this.hide();
      this._onBackdropClick = () => { if (this.closeOnOutside) this.hide(); };
      this._onKeyDown       = (e) => {
        if (this.open && e.key === 'Escape' && !this.requireButton) this.hide();
      };
      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp   = this._onPointerUp.bind(this);
      this._onSlotChange  = () => this._syncContent();
    }

    // ─── Lifecycle ───────────────────────────────────────────────────────────────

    connectedCallback() {
      DrawerElement.ensureGlobalStyles();
      this._mountPortal();
      document.addEventListener('keydown', this._onKeyDown);

      this._slotDefault.addEventListener('slotchange', this._onSlotChange);
      this._slotHeader.addEventListener('slotchange',  this._onSlotChange);

      if (this.hasAttribute('size'))    this._applySize(this.getAttribute('size'));
      if (this.hasAttribute('label'))   this._applyLabel(this.getAttribute('label'));
      if (this.hasAttribute('trigger')) this._connectTrigger(this.getAttribute('trigger'));
      if (this.hasAttribute('open'))    this._syncOpen(true);
    }

    disconnectedCallback() {
      if (this._isTouch()) {
        document.documentElement.classList.add('touch-device');
        this.isTouch = true;
      }

      document.removeEventListener('keydown', this._onKeyDown);
      this._rmWindowListeners();

      this._slotDefault.removeEventListener('slotchange', this._onSlotChange);
      this._slotHeader.removeEventListener('slotchange',  this._onSlotChange);

      if (this._triggerEl && this._triggerHandler) {
        this._triggerEl.removeEventListener('click', this._triggerHandler);
      }

      if (this._isMovMode()) this._restoreContent();

      this._backdrop?.removeEventListener('click', this._onBackdropClick);
      this._panel?.remove();
      this._panel = null;

      if (document.querySelectorAll('drawer-element').length === 0) {
        this._backdrop?.remove();
        this._blurEl?.remove();
      }
      this._backdrop = this._blurEl = null;

      this._releaseLock();
    }

    attributeChangedCallback(name, _old, val) {
      switch (name) {
        case 'open':      this._syncOpen(val !== null); break;
        case 'size':      if (val) this._applySize(val);  break;
        case 'label':     if (val) this._applyLabel(val); break;
        case 'trigger':   if (val) this._connectTrigger(val); break;
        case 'direction':
          if (this._panel) this._panel.dataset.dir = val || 'bottom';
          break;
      }
    }

    // ─── Interne Hilfsmethoden ────────────────────────────────────────────────────

    _isMovMode() {
      return (this.getAttribute('mode') || 'clone') === 'move';
    }

    _isTouch() {
      /*
      const coarse    = window.matchMedia('(pointer: coarse)').matches;
      const hoverNone = window.matchMedia('(hover: none)').matches;
      const anyCoarse = window.matchMedia('(any-pointer: coarse)').matches;
      const anyFine   = window.matchMedia('(any-pointer: fine)').matches;
      */
      return 'ontouchstart' in window;
    }

    _isMobile() {
      const breakpoint = parseInt(this.getAttribute('mobile-breakpoint') || '1024', 10);
      return window.innerWidth <= breakpoint && this._isTouch();
    }

    _mountPortal() {
      if (this._panel) return;

      let backdrop = document.getElementById('drw-backdrop');
      if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id        = 'drw-backdrop';
        backdrop.className = 'drw-backdrop';
        document.body.appendChild(backdrop);
      }
      backdrop.addEventListener('click', this._onBackdropClick);

      let blurEl = document.getElementById('drw-blur');
      if (!blurEl) {
        blurEl = document.createElement('div');
        blurEl.id        = 'drw-blur';
        blurEl.className = 'drw-blur';
        document.body.appendChild(blurEl);
      }

      this._backdrop = backdrop;
      this._blurEl   = blurEl;

      const panel = document.createElement('div');
      panel.className = 'drw-panel';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-hidden', 'true');
      panel.dataset.dir = this.getAttribute('direction') || 'bottom';

      const handle = document.createElement('div');
      handle.className = 'drw-handle';
      handle.addEventListener('pointerdown', this._onPointerDown);

      const header = document.createElement('div');
      header.className = 'drw-header';
      header.addEventListener('pointerdown', this._onPointerDown);

      const accent = document.createElement('span');
      accent.className = 'drw-accent';

      const title = document.createElement('h2');
      title.className   = 'drw-title';
      title.textContent = this.getAttribute('label') || 'Drawer';

      const closeBtn = document.createElement('button');
      closeBtn.className = 'drw-close';
      closeBtn.setAttribute('aria-label', 'Close drawer');
      closeBtn.innerHTML = `<svg viewBox="0 0 14 14" aria-hidden="true">
        <line x1="2" y1="2" x2="12" y2="12"/>
        <line x1="12" y1="2" x2="2" y2="12"/>
      </svg>`;
      closeBtn.addEventListener('click', this._onCloseClick);

      header.append(accent, title, closeBtn);

      const body = document.createElement('div');
      body.className = 'drw-body';

      panel.append(handle, header, body);
      document.body.appendChild(panel);

      this._panel  = panel;
      this._handle = handle;
      this._header = header;
      this._title  = title;
      this._body   = body;

      this._syncContent();
    }

    _syncContent() {
      if (!this._body) return;

      const headerNodes = this._slotHeader.assignedNodes({ flatten: true });
      if (headerNodes.length) {
        const accent   = this._header.querySelector('.drw-accent');
        const closeBtn = this._header.querySelector('.drw-close');
        Array.from(this._header.childNodes).forEach(n => {
          if (n !== accent && n !== closeBtn) n.remove();
        });
        const frag = document.createDocumentFragment();
        headerNodes.forEach(n => frag.appendChild(n.cloneNode(true)));
        this._header.insertBefore(frag, closeBtn);
      } else {
        if (!this._header.querySelector('.drw-title')) {
          const closeBtn = this._header.querySelector('.drw-close');
          this._header.insertBefore(this._title, closeBtn);
        }
      }

      const bodyNodes = this._slotDefault.assignedNodes({ flatten: true });

      if (this._isMovMode()) {
        this._body.innerHTML = '';
        this._movedNodes = [];
        bodyNodes.forEach(n => {
          const placeholder = document.createComment('drw-placeholder');
          n.parentNode.insertBefore(placeholder, n);
          this._body.appendChild(n);
          this._movedNodes.push({ node: n, placeholder });
        });
      } else {
        this._body.innerHTML = '';
        bodyNodes.forEach(n => this._body.appendChild(n.cloneNode(true)));
      }
    }

    _restoreContent() {
      for (const { node, placeholder } of this._movedNodes) {
        if (placeholder.parentNode) {
          placeholder.parentNode.insertBefore(node, placeholder);
          placeholder.remove();
        }
      }
      this._movedNodes = [];
    }

    // ─── Public API ──────────────────────────────────────────────────────────────

    show() {
      if (this.open) return;
      if (this.hasAttribute('mobile-only') && !this._isMobile()) return;
      this.setAttribute('open', '');
      this.dispatchEvent(new CustomEvent('drawer-open', { bubbles: true, composed: true }));
      this._focusFirst();
    }

    hide() {
      if (!this.open) return;
      this.removeAttribute('open');
      this.dispatchEvent(new CustomEvent('drawer-close', { bubbles: true, composed: true }));
      this._triggerEl?.focus();
    }

    toggle() { this.open ? this.hide() : this.show(); }

    // ─── Sync / Lock ─────────────────────────────────────────────────────────────

    _syncOpen(isOpen) {
      if (!this._panel) return;

      this._panel.classList.toggle('is-open', isOpen);
      this._backdrop.classList.toggle('is-open', isOpen);
      this._blurEl.classList.toggle('is-open', isOpen);
      this._panel.setAttribute('aria-hidden', String(!isOpen));

      if (isOpen) {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--drawer-scrollbar-width', `${sbw}px`);
        document.body.classList.add('drawer-open');
      } else {
        if (this._isMovMode()) {
          const onEnd = (e) => {
            if (e && e.propertyName !== 'transform') return;
            clearTimeout(fallback);
            this._panel.removeEventListener('transitionend', onEnd);
            this._restoreContent();
            this._releaseLock();
          };
          const fallback = setTimeout(() => { onEnd(null); }, 400);
          this._panel.addEventListener('transitionend', onEnd);
        } else {
          const onEnd = (e) => {
            if (e && e.propertyName !== 'transform') return;
            clearTimeout(fallback);
            this._panel.removeEventListener('transitionend', onEnd);
            this._releaseLock();
          };
          const fallback = setTimeout(onEnd, 400);
          this._panel.addEventListener('transitionend', onEnd);
        }
      }
    }

    _releaseLock() {
      const anyOpen = document.querySelectorAll('drawer-element[open]').length > 0;
      if (!anyOpen) {
        document.body.classList.remove('drawer-open');
        document.documentElement.style.removeProperty('--drawer-scrollbar-width');
      }
    }

    // ─── Properties ──────────────────────────────────────────────────────────────

    get open()            { return this.hasAttribute('open'); }
    set open(v)           { v ? this.setAttribute('open', '') : this.removeAttribute('open'); }

    get closeOnOutside()  { return !this.requireButton && this.hasAttribute('close-on-outside'); }
    set closeOnOutside(v) { v ? this.setAttribute('close-on-outside', '') : this.removeAttribute('close-on-outside'); }

    get requireButton()   { return this.hasAttribute('require-button'); }
    set requireButton(v)  { v ? this.setAttribute('require-button', '') : this.removeAttribute('require-button'); }

    get noDrag()          { return this.hasAttribute('no-drag'); }
    set noDrag(v)         { v ? this.setAttribute('no-drag', '') : this.removeAttribute('no-drag'); }

    get direction()       { return this.getAttribute('direction') || 'bottom'; }
    set direction(v)      { this.setAttribute('direction', v); }

    get size()            { return this.getAttribute('size') || ''; }
    set size(v)           { this.setAttribute('size', v); }

    get label()           { return this.getAttribute('label') || 'Drawer'; }
    set label(v)          { this.setAttribute('label', v); }

    get trigger()         { return this.getAttribute('trigger'); }
    set trigger(v)        { v ? this.setAttribute('trigger', v) : this.removeAttribute('trigger'); }

    get mode()            { return this.getAttribute('mode') || 'clone'; }
    set mode(v)           { this.setAttribute('mode', v); }

    // ─── Drag / Pointer ──────────────────────────────────────────────────────────

    _onPointerDown(e) {
      if (!this.open || this.requireButton || this.noDrag) return;
      if (e.button !== 0) return;
      if (e.target.closest('.drw-close')) return;

      e.currentTarget.setPointerCapture(e.pointerId);
      this._ds = {
        startX: e.clientX, startY: e.clientY,
        lastX:  e.clientX, lastY:  e.clientY,
        lastTime: performance.now(), delta: 0, velocity: 0,
      };
      this._panel.style.transition = 'none';
      this._handle.classList.add('is-dragging');
      window.addEventListener('pointermove',   this._onPointerMove, { passive: true });
      window.addEventListener('pointerup',     this._onPointerUp);
      window.addEventListener('pointercancel', this._onPointerUp);
    }

    _onPointerMove(e) {
      if (!this._ds) return;
      const ds  = this._ds;
      const now = performance.now();
      const dt  = now - ds.lastTime || 1;
      const dir = this.direction;

      const raw   = dir === 'right' ? e.clientX - ds.startX : e.clientY - ds.startY;
      const delta = Math.max(0, raw);

      ds.velocity = (dir === 'right' ? e.clientX - ds.lastX : e.clientY - ds.lastY) / dt;
      ds.lastX = e.clientX; ds.lastY = e.clientY; ds.lastTime = now; ds.delta = delta;

      const size = this._panelSize();
      const thr  = size * 0.6;
      const vis  = delta <= thr ? delta : thr + (delta - thr) * DrawerElement.RESISTANCE;

      const progress = Math.min(1, delta / size);
      this._backdrop.style.opacity = String(1 - progress * 0.85);
      this._blurEl.style.opacity   = String(1 - progress * 0.85);

      this._panel.style.transform = dir === 'right'
        ? `translateX(${vis}px)` : `translateY(${vis}px)`;
    }

    _onPointerUp() {
      if (!this._ds) return;
      const { delta, velocity } = this._ds;
      this._ds = null;

      this._handle.classList.remove('is-dragging');
      this._backdrop.style.opacity = '';
      this._blurEl.style.opacity   = '';
      this._rmWindowListeners();

      const size    = this._panelSize();
      const dismiss = velocity > DrawerElement.VELOCITY_THRESHOLD
                  || delta    > size * DrawerElement.DISTANCE_RATIO;

      if (dismiss) {
        this._panel.style.transition = `transform ${DrawerElement.DISMISS_DUR} ${DrawerElement.DISMISS_EASE}`;
        this._panel.style.transform  = this.direction === 'right'
          ? `translateX(${size + 40}px)` : `translateY(${size + 40}px)`;
        this._panel.addEventListener('transitionend', () => {
          this._panel.style.transition = '';
          this._panel.style.transform  = '';
          this.hide();
        }, { once: true });
      } else {
        this._panel.style.transition = `transform ${DrawerElement.SPRING_DUR} ${DrawerElement.SPRING_EASE}`;
        this._panel.style.transform  = '';
        this._panel.addEventListener('transitionend', () => {
          this._panel.style.transition = '';
        }, { once: true });
      }
    }

    _rmWindowListeners() {
      window.removeEventListener('pointermove',   this._onPointerMove);
      window.removeEventListener('pointerup',     this._onPointerUp);
      window.removeEventListener('pointercancel', this._onPointerUp);
    }

    _panelSize() {
      const r = this._panel.getBoundingClientRect();
      return this.direction === 'right' ? r.width : r.height;
    }

    // ─── Kleine Helpers ───────────────────────────────────────────────────────────

    _applySize(val) {
      if (this._panel) this._panel.style.setProperty('--drw-size', val);
      else requestAnimationFrame(() => this._applySize(val));
    }

    _applyLabel(val) {
      if (this._title) this._title.textContent = val;
      if (this._panel) this._panel.setAttribute('aria-label', val);
    }

    _connectTrigger(selector) {
      // Alte Trigger-Listener entfernen
      if (this._triggerEls && this._triggerHandler) {
        this._triggerEls.forEach(el => el.removeEventListener('click', this._triggerHandler));
        this._triggerEls = null;
      }

      const root = this.getRootNode();
      const els = Array.from(
        (root && typeof root.querySelectorAll === 'function')
          ? root.querySelectorAll(selector)
          : document.querySelectorAll(selector)
      );

      if (!els.length) { requestAnimationFrame(() => this._connectTrigger(selector)); return; }

      this._triggerEl  = els[0]; // für focus() beim Schließen
      this._triggerEls = els;
      this._triggerHandler = (e) => {
        if (this.hasAttribute('mobile-only') && !this._isMobile()) return;
        e.preventDefault();
        this.toggle();
      };

      els.forEach(el => {
        el.addEventListener('click', this._triggerHandler);
        el.setAttribute('aria-haspopup', 'dialog');
      });
    }

    _focusFirst() {
      requestAnimationFrame(() => {
        this._panel?.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )?.focus();
      });
    }
  }

  customElements.define('drawer-element', DrawerElement);